// Auto-generated from design-tokens/colors.json — do not edit manually.
// Source: Figma Elements New

export const mainLight = {
  CONTENT_PRIMARY: '#02151E',
  CONTENT_SECONDARY: '#505D63',
  DISABLE_CONTENT: '#B1BBBF',
  HOVER: '#E7F0F3',
  BACKGROUND_PRIMARY: '#FFFFFF',
  BACKGROUND_SECONDARY: '#F2F4F5',
  DISABLE_BACKGROUND: '#E5E9EB',
  SECTIONS_BACKGROUNDS: '#E5E9EB',
  DIVIDER: '#CFD9DC',
  TOOLTIPS: 'rgba(2, 21, 30, 0.9)',
  HINTS: '#02151E',
} as const;

export const mainDark = {
  CONTENT_PRIMARY: '#FFFFFF',
  CONTENT_SECONDARY: '#B1BBBF',
  DISABLE_CONTENT: '#595959',
  HOVER: '#768084',
  BACKGROUND_PRIMARY: '#2B2D30',
  BACKGROUND_SECONDARY: '#1E1F22',
  DISABLE_BACKGROUND: '#3F3F3F',
  SECTIONS_BACKGROUNDS: '#3F3F3F',
  DIVIDER: '#404244',
  TOOLTIPS: '#FFFFFF',
  HINTS: '#FFFFFF',
} as const;

export const red = {
  RED_01: '#F04465',
  RED_02: '#EF5683',
  RED_03: '#F17297',
  RED_04: '#F48EAC',
  RED_05: '#F7ABC1',
  RED_06: '#FAC7D6',
  RED_07: '#FCE3EA',
  RED_OPACITY: 'rgba(240, 68, 101, 0.2)',
  RED_OPACITY_10: 'rgba(240, 68, 101, 0.1)',
} as const;

export const orange = {
  ORANGE_01: '#FE5C00',
  ORANGE_02: '#FE7324',
  ORANGE_03: '#FE8B49',
  ORANGE_04: '#FEA26D',
  ORANGE_05: '#FFB992',
  ORANGE_06: '#FFD0B6',
  ORANGE_07: '#FFE8DB',
  ORANGE_OPACITY_02: 'rgba(254, 92, 0, 0.2)',
  ORANGE_OPACITY_01: 'rgba(254, 92, 0, 0.1)',
} as const;

export const yellow = {
  YELLOW_01: '#FFC647',
  YELLOW_02: '#FFCE61',
  YELLOW_03: '#FFD67C',
  YELLOW_04: '#FFDE96',
  YELLOW_05: '#FFE7B0',
  YELLOW_06: '#FFEFCA',
  YELLOW_07: '#FFF7E5',
  YELLOW_OPACITY: 'rgba(255, 198, 71, 0.2)',
  YELLOW_OPACITY_10: 'rgba(255, 198, 71, 0.1)',
} as const;

export const blue = {
  BLUE_01: '#008EDD',
  BLUE_02: '#4F9ADE',
  BLUE_03: '#5FA8E2',
  BLUE_04: '#73B6E8',
  BLUE_05: '#88C5EC',
  BLUE_06: '#B9E1F6',
  BLUE_07: '#CAF1FD',
  BLUE_OPACITY: 'rgba(0, 142, 221, 0.2)',
  BLUE_OPACITY_10: 'rgba(0, 142, 221, 0.1)',
} as const;

export const grey = {
  GREY_01: '#B1BBBF',
  GREY_02: '#CFD9DC',
  GREY_03: '#DEE4E6',
  GREY_04: '#E5E9EB',
  GREY_05: '#EBEFF0',
  GREY_06: '#F2F4F5',
  GREY_07: '#F9FAFA',
  GREY_OPACITY: 'rgba(177, 187, 191, 0.2)',
  GREY_OPACITY_10: 'rgba(177, 187, 191, 0.1)',
} as const;

export const darkGreen = {
  DARK_GREEN_01: '#29A072',
  DARK_GREEN_02: '#48AE86',
  DARK_GREEN_03: '#66BB9A',
  DARK_GREEN_04: '#85C9AE',
  DARK_GREEN_05: '#A3D6C3',
  DARK_GREEN_06: '#C2E4D7',
  DARK_GREEN_07: '#E0F1EB',
  DARK_GREEN_OPACITY_20: 'rgba(41, 160, 114, 0.2)',
  DARK_GREEN_OPACITY_10: 'rgba(41, 160, 114, 0.1)',
} as const;

export const lightGreen = {
  LIGHT_GREEN_01: '#71FFC3',
  LIGHT_GREEN_02: '#81FFCA',
  LIGHT_GREEN_03: '#91FFD1',
  LIGHT_GREEN_04: '#A1FFD8',
  LIGHT_GREEN_05: '#B0FFDF',
  LIGHT_GREEN_06: '#C0FFE5',
  LIGHT_GREEN_07: '#D0FFEC',
  LIGHT_GREEN_OPACITY_20: 'rgba(113, 255, 195, 0.2)',
  LIGHT_GREEN_OPACITY_10: 'rgba(113, 255, 195, 0.1)',
} as const;

export const green = {
  GREEN_01: '#29A072',
  GREEN_02: '#48AE86',
  GREEN_03: '#66BB9A',
  GREEN_04: '#A1FFD8',
  GREEN_05: '#B0FFDF',
  GREEN_06: '#C0FFE5',
  GREEN_07: '#D0FFEC',
  GREEN_DATA: '#71FFC3',
  GREEN_OPACITY: 'rgba(113, 255, 195, 0.2)',
} as const;

export const VaultColors = {
  PINK: '#FEB2F1',
  LIGHT_BLUE: '#8AE3FF',
  PURPLE: '#BDBEF7',
  PEACH: '#E3B2A1',
  BROWN: '#D1B9C0',
  GREEN: '#A1FFD8',
} as const;

export const graphPink = {
  PINK_G_01: '#EDB6C9',
  PINK_G_02: '#F1D0F3',
  PINK_G_03: '#FBE2E5',
  PINK_G_04: '#E4BAD4',
  PINK_G_05: '#F2CDDA',
} as const;

export const graphLightBlue = {
  LIGHT_BLUE_G_01: '#B0E0E6',
  LIGHT_BLUE_G_02: '#B6CFED',
  LIGHT_BLUE_G_03: '#CDE7FF',
  LIGHT_BLUE_G_04: '#C2F0FC',
  LIGHT_BLUE_G_05: '#A5D8FF',
} as const;

export const graphPurple = {
  PURPLE_G_01: '#D0C4DF',
  PURPLE_G_02: '#E3E2FD',
  PURPLE_G_03: '#D8B4F8',
  PURPLE_G_04: '#E0D0F3',
  PURPLE_G_05: '#D9D7F1',
} as const;

export const graphPeach = {
  PEACH_G_01: '#F2D2CD',
  PEACH_G_02: '#E1D7C1',
  PEACH_G_03: '#FFD6A5',
  PEACH_G_04: '#F3DED0',
  PEACH_G_05: '#FFCBCB',
} as const;

export const graphBrown = {
  BROWN_G_01: '#E1C7C1',
  BROWN_G_02: '#EDBCB6',
  BROWN_G_03: '#EF9B8F',
  BROWN_G_04: '#EED0B4',
  BROWN_G_05: '#F7D5C1',
} as const;

export const graphGreen = {
  GREEN_G_01: '#D5E59A',
  GREEN_G_02: '#B2D3C2',
  GREEN_G_03: '#9AE5A7',
  GREEN_G_04: '#E2F8D1',
  GREEN_G_05: '#9AE5CB',
} as const;
